module.exports = __webpack_public_path__ + "img/icon_my.c6e97d9.webp";